class MediaPopup {
    constructor() {
        const mediaLinks = document.querySelectorAll('a.videopopup, a[href*="#videopopup"], a.imagepopup, a[href*="#imagepopup"]');

        // Do not run in Episerver edit mode
        if (mediaLinks.length && !$('body').data('editmode')) {
            this.initPopup();
            //this.addIconsToButtons(); // Add video icon to buttons
        }
    }

    initPopup() {
        this.createModal();

        document.querySelectorAll('a.videopopup, a[href*="#videopopup"], a.imagepopup, a[href*="#imagepopup"]').forEach(link => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                const mediaUrl = this.extractMediaUrl(link.getAttribute('href'));
                const type = link.classList.contains('videopopup') || link.getAttribute('href').includes('#videopopup') ? 'video' : 'image';
                this.openModal(mediaUrl, type);
            });
        });

        // Close modal when clicking the X button
        document.body.addEventListener('click', (event) => {
            if (event.target.closest('.media-close')) {
                this.closeModal();
            }
        });

        // Close modal when clicking outside the media content
        document.body.addEventListener('click', (event) => {
            const modal = document.getElementById('mediaModal');
            if (modal && event.target === modal) {
                this.closeModal();
            }
        });
    }

    //Commented out because different button icons were introduced
    //addIconsToButtons() {
    //    document.querySelectorAll('a.videopopup.btn, a[href*="#videopopup"].btn').forEach(button => {
    //        if (!button.querySelector('.video-icon')) { // Prevent duplicate icons
    //            const icon = document.createElement('span');
    //            icon.classList.add('video-icon');
    //            icon.innerHTML = `
    //                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" width="39px" height="39px">
    //                    <g transform="translate(1 1)" fill="none" fill-rule="evenodd"><circle stroke="#FFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" cx="18.208" cy="18.208" r="18.208"></circle><path fill="#FFF" d="M26 18l-12 7V11z"></path></g>
    //                </svg>
    //            `;
    //            button.prepend(icon);
    //        }
    //    });
    //}

    createModal() {
        if (!document.getElementById('mediaModal')) {
            const modalHTML = `
                <div id="mediaModal" class="media-modal">
                    <div class="media-content">
                        <span class="media-close">&times;</span>
                        <div id="mediaContainer"></div>
                    </div>
                </div>
            `;
            document.body.insertAdjacentHTML('beforeend', modalHTML);
        }
    }

    openModal(mediaUrl, type) {
        if (!mediaUrl) return;
        const mediaContainer = document.getElementById('mediaContainer');
        const embedCode = this.getEmbedCode(mediaUrl, type);

        if (!embedCode) {
            // Redirect if media cannot be displayed
            window.location.href = mediaUrl;
            return;
        }

        mediaContainer.innerHTML = embedCode;
        document.getElementById('mediaModal').style.display = 'flex';
        document.getElementById("hero-video").pause();
    }

    closeModal() {
        const modal = document.getElementById('mediaModal');
        if (modal) {
            modal.style.display = 'none';
            document.getElementById('mediaContainer').innerHTML = '';
        }
        document.getElementById("hero-video").play();
    }

    extractMediaUrl(href) {
        return href.split('#')[0]; // Remove #videopopup or #imagepopup
    }

    getEmbedCode(url, type) {
        if (type === 'video') {
            return `
                <video controls autoplay>
                    <source src="${url}" type="video/mp4">
                    Your browser does not support the video tag.
                </video>`;
        }

        if (type === 'image') {
            return `<img src="${url}" alt="Media preview">`;
        }

        return null; // Return null to trigger redirect
    }
}

export default MediaPopup;
